module.exports = __webpack_public_path__ + "img/JM.4622fe12.svg";